var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptycart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 402,
    viewBox: "0 0 560 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 220.5,
    r: 175.5,
    fill: "#F4F4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 102,
    r: 11,
    fill: "#F4F4F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.5,
    cy: 24.5,
    r: 20.5,
    fill: "#F4F4F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 360.5,
    r: 19.5,
    fill: "#F4F4F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.5,
    cy: 314.5,
    r: 19.5,
    fill: "#F4F4F4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.5,
    cy: 336.5,
    r: 9.5,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.525 53.537C289.946 53.4137 289.946 52.5863 290.525 52.463L299.291 50.5989C299.502 50.554 299.668 50.3894 299.713 50.1783L301.601 41.4744C301.726 40.8975 302.549 40.8975 302.674 41.4744L304.561 50.1783C304.607 50.3894 304.772 50.554 304.984 50.5989L313.749 52.463C314.329 52.5863 314.329 53.4137 313.749 53.537L304.984 55.4011C304.772 55.446 304.607 55.6106 304.561 55.8217L302.674 64.5256C302.549 65.1025 301.726 65.1025 301.601 64.5256L299.713 55.8217C299.668 55.6106 299.502 55.446 299.291 55.4011L290.525 53.537Z",
    fill: "url(#paint0_linear_2250_2)",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2229 232.622C90.4467 231.565 91.9558 231.565 92.1796 232.622L95.5224 248.415C95.6038 248.799 95.9034 249.101 96.2878 249.185L111.917 252.589C112.967 252.818 112.967 254.315 111.917 254.544L96.2878 257.948C95.9034 258.032 95.6038 258.334 95.5224 258.718L92.1796 274.511C91.9558 275.568 90.4467 275.568 90.2229 274.511L86.8801 258.718C86.7986 258.334 86.499 258.032 86.1146 257.948L70.4851 254.544C69.4356 254.315 69.4356 252.818 70.4851 252.589L86.1146 249.185C86.499 249.101 86.7986 248.799 86.8801 248.415L90.2229 232.622Z",
    fill: "url(#paint1_linear_2250_2)",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M437.345 106.622C437.568 105.565 439.078 105.565 439.301 106.622L441.251 115.835C441.333 116.22 441.633 116.521 442.017 116.605L451.161 118.597C452.21 118.826 452.21 120.323 451.161 120.551L442.017 122.543C441.633 122.627 441.333 122.928 441.251 123.313L439.301 132.526C439.078 133.583 437.568 133.583 437.345 132.526L435.395 123.313C435.313 122.928 435.014 122.627 434.629 122.543L425.485 120.551C424.436 120.323 424.436 118.826 425.485 118.597L434.629 116.605C435.014 116.521 435.313 116.22 435.395 115.835L437.345 106.622Z",
    fill: "url(#paint2_linear_2250_2)",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.658 254.33L480.72 268.797L494.981 271.904L480.72 275.011L477.658 289.478L474.596 275.011L460.335 271.904L474.596 268.797L477.658 254.33Z",
    fill: "url(#paint3_linear_2250_2)",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M380 141L143.5 231.5L194 372L224.5 385.5L262.5 393.5L301 392L323.5 388L343.5 382L376.5 365L404.5 343L406.662 340.206C418.865 324.431 429.684 307.634 439 290L380 141Z",
    fill: "url(#paint4_linear_2250_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 191.5L136.5 177.5L353.5 95.5L342 124L350.5 150.5L171 219L161.5 191.5Z",
    fill: "#EFD3CA",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193 371.5V371.5C214.882 382.688 238.572 389.913 262.973 392.841L263.582 392.915L280.979 392.915C294.011 392.915 307.005 391.528 319.743 388.777L324.056 387.846C337.675 384.906 350.824 380.104 363.134 373.576V373.576C372.738 368.483 381.767 362.373 390.066 355.351L392.76 353.072C399.962 346.977 406.645 340.295 412.739 333.092V333.092C421.272 323.008 428.601 311.964 434.579 300.184L440 289.5",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.581 229.414L194 372.467",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.081 140.914L439.587 291.172",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.582 177.914L356.575 93.7454",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.423 231.992L378.931 140.012L343.77 123.682C342.761 123.214 342.328 122.011 342.808 121.006L355.053 95.3845",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.591 177.223L159.804 190.741C160.762 191.254 161.134 192.44 160.642 193.409L141.582 230.914",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.582 175.414L149.828 216.022",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161 193L171 221",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343 123L353 152",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.229 95.8516L369.582 135.414",
    stroke: "#FE9C89",
    strokeWidth: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 218.5,
    r: 10.5,
    fill: "#EFD3CA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 235.5,
    cy: 218.5,
    r: 10.5,
    stroke: "#FE9C89"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 164.5,
    r: 7.5,
    fill: "#F4F4F4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 164.5,
    r: 7.5,
    stroke: "#FE9C89"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.5,
    cy: 193.5,
    r: 10.5,
    fill: "#EFD3CA"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.5,
    cy: 193.5,
    r: 10.5,
    stroke: "#FE9C89"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 147.5,
    r: 7.5,
    fill: "#F4F4F4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.5,
    cy: 147.5,
    r: 7.5,
    stroke: "#FE9C89"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M309.17 240.358C294.157 244.951 312.654 252.253 317.815 239.599C317.931 239.396 313.19 239.272 312.742 239.497C312.276 239.676 308.778 240.351 309.17 240.358Z",
    fill: "#FF8E6F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M315.169 244.568C322.703 248.978 336.234 250.486 322.02 241.733C322.3 241.626 321.547 240.829 320.252 240.241C318.957 239.653 317.624 239.474 317.345 239.582C317.066 239.689 313.874 243.98 315.169 244.568Z",
    fill: "#FF8E6F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.503 260.52C259.29 260.796 260.4 260.711 260.692 260.994C262.012 261.013 267.46 265.343 268.594 267.277C268.951 267.824 271.738 274.812 274.811 282.795C278.226 291.542 280.639 297.304 280.85 297.223C281.274 297.06 293.293 267.252 294.493 263.419C295.407 260.486 297.997 257.486 300.991 255.913C303.063 254.852 303.794 254.728 305.799 255.01C307.07 255.153 308.867 255.778 309.743 256.284C313.238 258.415 313.613 259.009 318.66 271.869C323.955 285.372 324.315 286.181 325.657 287.14C329.305 289.792 349.116 300.447 349.879 300.153C350.006 300.104 345.675 288.601 340.288 274.607C333.418 256.759 330.317 249.207 330.02 249.322C329.766 249.419 330.251 250.3 330.219 249.838C330.184 248.482 326.715 244.272 326.076 244.887C325.656 245.312 325.501 245.161 325.419 244.192C325.31 243.022 317.285 238.222 324.967 244.155C324.823 244.79 324.837 245.838 325.067 246.435C325.402 247.306 325.328 247.493 324.848 247.256C324.308 246.99 324.138 246.423 324.247 245.064C324.318 242.719 324.159 242.306 323.569 243.429C323.287 243.959 323.135 244.07 323.181 243.684C323.244 243.343 323.061 242.992 322.736 242.907C322.429 242.867 322.383 243.253 322.57 243.866C322.846 244.708 322.708 244.603 322.03 243.6C320.865 241.836 320.031 241.314 318.097 241.215C316.656 241.138 316.596 241.108 317.111 240.172C317.644 239.282 317.584 239.253 316.734 239.949C316.211 240.361 315.71 241.081 315.555 241.562C315.41 242.197 314.743 242.612 313.334 242.996C312.24 243.312 311.368 243.7 311.439 243.884C311.492 244.021 310.959 244.279 310.185 244.419C309.43 244.604 308.738 244.449 308.597 244.082C308.42 243.623 307.799 243.652 306.57 244.125C304.24 245.021 304.516 244.599 307.273 243.169C308.769 242.382 309.338 242.216 309.02 242.655C308.469 243.499 308.826 243.414 311.738 242.135C314.778 240.807 315.251 240.52 315.074 240.061C314.968 239.786 314.831 239.681 314.721 239.775C314.612 239.87 313.817 240.334 312.956 240.876C311.774 241.595 311.502 241.647 311.826 241.1C312.151 240.554 310.531 241.02 305.896 242.751L299.506 245.105L310.402 244.033C313.042 242.805 309.263 240.507 309.313 240.382C309.535 239.823 263.842 257.806 262.675 258.597C262.174 258.685 267.168 257.54 266.9 257.221C266.692 256.933 260.606 258.656 259.293 259.162L257.09 260.01L258.503 260.52ZM319.686 242.816C319.683 242.755 319.691 242.704 319.71 242.663C319.808 242.451 320.174 242.502 320.557 242.703C320.971 242.919 321.407 243.311 321.546 243.733C321.723 244.192 321.638 244.225 321.292 243.831C321.177 243.685 320.817 243.634 320.383 243.68C320.095 243.71 319.774 243.783 319.47 243.9C318.436 244.298 319.801 244.417 320.383 243.68C320.563 243.45 320.668 243.139 320.602 242.727C320.603 242.718 320.587 242.71 320.557 242.703C320.434 242.672 320.082 242.656 319.71 242.663C319.074 242.673 318.384 242.749 318.708 242.929C319.368 243.255 319.7 243.232 319.686 242.816ZM316.936 244.138C317.892 244.35 317.421 243.109 315.642 243.793C314.795 244.12 313.278 245.295 313.282 245.557C314.264 244.898 316.378 244.001 316.936 244.138ZM327.291 245.895C327.432 246.262 327.471 246.615 327.386 246.648C327.302 246.681 327.008 246.425 326.698 246.123C326.429 245.805 326.39 245.451 326.602 245.369C326.856 245.272 327.15 245.527 327.291 245.895Z",
    fill: "#FF8E6F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M327.291 245.895C327.432 246.262 327.471 246.615 327.386 246.648C327.302 246.681 327.008 246.425 326.698 246.123C326.429 245.805 326.39 245.451 326.602 245.369C326.856 245.272 327.15 245.527 327.291 245.895Z",
    fill: "#FF8E6F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M320.602 242.727C321.003 242.948 321.412 243.326 321.546 243.733C321.723 244.192 321.638 244.225 321.292 243.831C321.177 243.685 320.817 243.634 320.383 243.68C320.563 243.45 320.668 243.139 320.602 242.727Z",
    fill: "#FF8E6F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M319.71 242.663C319.808 242.451 320.174 242.502 320.557 242.703C320.434 242.672 320.082 242.656 319.71 242.663Z",
    fill: "#FF8E6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.453 270.866C247.899 271.448 246.978 272.593 246.445 273.483C245.238 275.528 243.605 281.898 244.173 282.365C244.406 282.591 244.345 281.706 244.133 281.787C243.879 281.885 243.905 284.575 244.093 286.452C244.446 290.53 247.58 299.175 249.96 302.579C251.376 304.615 254.565 307.971 256.38 309.274C257.799 310.308 264.518 313.991 272.169 317.947L279.461 321.725L270.319 297.85C261.912 276.01 260.998 273.886 259.755 272.679C259.038 271.954 258.588 271.482 257.781 271.595C257.212 271.222 260.879 273.168 257.238 270.816C257.09 270.557 256.506 270.558 256.376 270.345C256.192 269.994 252.379 269.565 250.508 269.759C249.989 269.801 249.067 270.313 248.453 270.866Z",
    fill: "#FF8E6F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M303.777 268.52C302.401 270.631 300.626 275.37 301.057 275.731C301.29 275.958 300.995 275.571 300.958 275.98C300.633 275.894 299.973 276.833 299.479 278.077C298.985 279.321 298.805 280.496 299.081 280.706C299.314 280.933 301.826 274.411 301.458 274.342C301.074 274.227 297.828 281.874 297.185 283.49C296.593 284.983 293.717 292.043 290.834 299.211L285.569 312.195L288.43 319.628L291.273 327.015L300.828 331.871C306.025 334.507 311.134 336.913 312.108 337.17C314.28 337.756 320.603 336.113 327.395 333.288L331.917 331.389L319.603 299.779C312.807 282.376 307.015 267.959 306.722 267.703C306.326 267.434 305.994 267.456 305.804 267.846C305.246 268.798 304.134 269.7 304.236 269.081C304.258 268.757 303.846 270.657 304.185 270.527C304.524 270.396 306.695 268.046 306.607 267.816C306.36 267.174 304.646 267.238 303.777 268.52Z",
    fill: "#FF8E6F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M330.841 303.952C330.926 304.551 333.042 310.427 335.55 316.943L340.124 328.826L344.865 326.738C350.351 324.31 352.176 322.607 353.478 318.787C354.632 315.34 353.875 310.468 352.198 310.534C346.733 310.741 341.37 309.066 334.347 304.973C331.085 303.068 330.7 302.953 330.841 303.952Z",
    fill: "#FF8E6F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2250_2",
    x1: 288,
    y1: 53,
    x2: 316.275,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2250_2",
    x1: 91.2012,
    y1: 228,
    x2: 91.2012,
    y2: 279.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2250_2",
    x1: 438.323,
    y1: 102,
    x2: 438.323,
    y2: 137.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2250_2",
    x1: 477.658,
    y1: 254.33,
    x2: 477.658,
    y2: 289.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2250_2",
    x1: 333,
    y1: 394,
    x2: 259,
    y2: 185.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FFE4DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycart);
export default __webpack_public_path__ + "static/media/emptycart.c20d663c78a8d1b110fb74635eea2c70.svg";
export { ForwardRef as ReactComponent };